class AnnouncementBar extends HTMLElement {
  constructor() {
    super();

    this.closeButton = this.querySelector("[data-close-button]");
    this.announcementBar = document.querySelector(".utility-bar");

    if(this.closeButton) {
      this.closeButton.addEventListener("click", this.close.bind(this));
    }
    window.addEventListener("resize", this.updateBarHeight.bind(this));
  }

  connectedCallback() {
    this.checkClosedState();

    window.addEventListener('load', this.updateBarHeight.bind(this));
  }

  disconnectedCallback() {
    this.closeButton.removeEventListener("click", this.close);
  }

  checkClosedState() {
    const isClosed = sessionStorage.getItem("announcementClosed");
    if (isClosed) {
      if(this.announcementBar) {
        this.announcementBar.classList.add('is-hidden');
      }
      document.documentElement.style.setProperty(
        "--announcement-bar-height",
        "0px"
      );
    }
  }

  close() {
    if(this.announcementBar) {
      this.announcementBar.classList.add('is-hidden');
    }
    document.documentElement.style.setProperty(
      "--announcement-bar-height",
      "0px"
    );
    sessionStorage.setItem("announcementClosed", "true");
  }

  updateBarHeight() {
    if(!this.announcementBar) return;
    const barHeight = this.announcementBar.offsetHeight + "px";
    document.documentElement.style.setProperty("--announcement-bar-height", barHeight);
  }
}

customElements.define("announcement-bar", AnnouncementBar);
